import React__default from 'react';
import classnames from 'classnames';
import ownClasses from './index.module.scss.js';
import { Button } from '../../Button/index.js';
import '../../../Icons/ArrowDown/index.js';
import '../../../Icons/Camera/index.js';
import '../../../Icons/Category/index.js';
import '../../../Icons/CheckCircle/index.js';
import { Close } from '../../../Icons/Close/index.js';
import '../../../Icons/Favorite/index.js';
import '../../../Icons/Lens/index.js';
import '../../../Icons/LensHeart/index.js';
import '../../../Icons/Phone/index.js';
import '../../../Icons/Pin/index.js';
import '../../../Icons/Promo/index.js';
import '../../../Icons/Share/index.js';
import '../../../Icons/Bell/index.js';
import '../../../Icons/Bin/index.js';
import '../../../Icons/Check/index.js';
import '../../../Icons/TriangleExclamation/index.js';
import '../../../Icons/ShoppingBag/index.js';

const BalloonBasic = function ({ arrowPosition, classes = [], type = 'informative', hasCloseButton = false, isPartOfATooltip = true, onClose, children, id, }) {
    return (React__default.createElement("div", { className: classnames(ownClasses['bubble'], ownClasses[arrowPosition], ownClasses[type], ...classes), role: isPartOfATooltip ? 'tooltip' : undefined, id: id },
        React__default.createElement("div", { className: ownClasses['bubble-content'] },
            React__default.createElement("div", { className: classnames({
                    [ownClasses['bubble-content-wrapper']]: true,
                    [ownClasses['has-close-button']]: hasCloseButton,
                }) }, children),
            hasCloseButton && (React__default.createElement(Button, { classes: [ownClasses['close-button']], design: 'text', "aria-label": "Chiudi la tooltip", onClick: () => onClose?.() },
                React__default.createElement(Close, null))))));
};

export { BalloonBasic };
//# sourceMappingURL=index.js.map
